import { render, staticRenderFns } from "./HolidyPz.vue?vue&type=template&id=54bbf93d&scoped=true&"
import script from "./HolidyPz.vue?vue&type=script&lang=js&"
export * from "./HolidyPz.vue?vue&type=script&lang=js&"
import style0 from "./HolidyPz.vue?vue&type=style&index=0&id=54bbf93d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbf93d",
  null
  
)

export default component.exports